import { render, staticRenderFns } from "./AdminPortalOktaLogin.vue?vue&type=template&id=24e67b6c&scoped=true"
import script from "./AdminPortalOktaLogin.vue?vue&type=script&lang=ts"
export * from "./AdminPortalOktaLogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e67b6c",
  null
  
)

export default component.exports